import { defineComponent } from 'vue';

export default defineComponent({
  name: 'InvalidMessageView',
  setup() {
    const unknownMessageFlag = true;
    return {
      unknownMessageFlag,
    };
  },
});
